import React from "react";
import CLI from "components/CLI";

const App = () => {
    return (
        <CLI />
    );
};

export default App;